let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Z2F4V")).then(() => parcelRequire('4qy1c'));